import { Box, Theme, Tooltip, Typography, useMediaQuery } from '@mui/material';
import { UserWalletWithFundsCount } from 'src/services/wallet';

const MAX_WIDTH_NAME = 60;
const MAX_WIDTH_NAME_MOBILE = 30;

interface WalletInfoProps {
  wallet: UserWalletWithFundsCount;
  selected: boolean;
  onSelect: () => void;
}

export function WalletInfo({ wallet, selected, onSelect }: WalletInfoProps) {
  const isMobile = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down('sm'),
  );
  const handleSelect = () => {
    if (wallet.isFundMonitored) return;
    onSelect();
  };

  const displayWalletName =
    isMobile && wallet.name.length > MAX_WIDTH_NAME_MOBILE
      ? wallet.name.slice(0, MAX_WIDTH_NAME_MOBILE) + '...'
      : wallet.name.length > MAX_WIDTH_NAME
        ? wallet.name.slice(0, MAX_WIDTH_NAME) + '...'
        : wallet.name;

  return (
    <Tooltip title={isMobile ? wallet.name : undefined} arrow>
      <Box
        role="button"
        tabIndex={wallet.isFundMonitored ? -1 : 0}
        onClick={wallet.isFundMonitored ? undefined : handleSelect}
        onKeyDown={(event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            handleSelect();
          }
        }}
        sx={{
          flex: 1,
          minWidth: 0,
          px: 1,
          py: 0.5,
          borderRadius: 2,
          border: 2,
          borderColor: selected ? 'primary.main' : 'divider',
          bgcolor: selected ? 'rgba(255, 130, 17, 0.06)' : 'background.paper',
          transition: 'border-color 150ms, background-color 150ms',
          cursor: wallet.isFundMonitored ? 'default' : 'pointer',
          opacity: wallet.isFundMonitored ? 0.5 : 1,
          '&:hover': {
            borderColor: selected ? 'primary.main' : 'text.disabled',
          },
        }}>
        <Typography variant="body1" fontWeight={600} lineHeight={1.2}>
          {displayWalletName}
        </Typography>
        <Typography variant="caption" color="text.secondary">
          {wallet.fundsCount} {wallet.fundsCount === 1 ? 'Fundo' : 'Fundos'}
          {wallet.isFundMonitored && '- já monitorando este fundo'}
        </Typography>
      </Box>
    </Tooltip>
  );
}
